import React, { useMemo } from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';


const ShoeItemCard = ({ item, index, services, servicesLoading, onUpdate, onRemove, showRemove }) => {
  const serviceMap = useMemo(() => {
    return new Map((services || []).map((s) => [s.id, s]));
  }, [services]);

  const serviceOptions = useMemo(() => {
    const base = [{ value: '', label: servicesLoading ? '서비스 불러오는 중...' : '서비스 선택', disabled: true }];
    return base.concat(
      (services || []).map((s) => {
        const basePrice = Number(s?.base_price || 0);
        const promoPrice = Number(s?.promotional_price || 0);
        const hasPromo = promoPrice > 0 && promoPrice < basePrice;
        const priceLabel = hasPromo
          ? `${promoPrice?.toLocaleString('ko-KR')}원 (프로모션)`
          : `${basePrice?.toLocaleString('ko-KR')}원`;

        return {
          value: s.id,
          label: `${s?.name} - ${priceLabel}`,
          description: hasPromo ? `정상가 ${basePrice?.toLocaleString('ko-KR')}원` : undefined,
        };
      })
    );
  }, [services, servicesLoading]);

  const selectedService = item?.serviceId ? serviceMap.get(item.serviceId) : null;
  const basePrice = Number(selectedService?.base_price || 0);
  const promoPrice = Number(selectedService?.promotional_price || 0);
  const hasPromo = promoPrice > 0 && promoPrice < basePrice;
  const discountAmount = hasPromo ? Math.max(0, basePrice - promoPrice) : 0;
  const effectivePrice = hasPromo ? promoPrice : basePrice;

  const handleServiceChange = (value) => {
    onUpdate(index, 'serviceId', value);

    const svc = value ? serviceMap.get(value) : null;
    const base = Number(svc?.base_price || 0);
    const promo = Number(svc?.promotional_price || 0);
    const nextHasPromo = promo > 0 && promo < base;
    onUpdate(index, 'priceMode', nextHasPromo ? 'promo' : 'base');
  };

  const handlePriceModeChange = (mode) => {
    onUpdate(index, 'priceMode', mode);
  };

  return (
    <div className="rounded-lg border border-border bg-muted/30 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-semibold text-foreground">신발 {index + 1}</h3>
        {showRemove && (
          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            iconSize={16}
            onClick={() => onRemove(index)}
          >
            삭제
          </Button>
        )}
      </div>
      <Select
        label="서비스 종류"
        options={serviceOptions}
        value={item?.serviceId}
        onChange={handleServiceChange}
        placeholder="서비스를 선택하세요"
        required
      />

      <Input
        label="메모"
        type="text"
        name="memo"
        placeholder="예: 나이키/검정, 아디다스/핑크 등"
        value={item?.memo || ''}
        onChange={(e) => onUpdate(index, 'memo', e?.target?.value)}
        className="mt-3 bg-white"
      />

      {selectedService && (
        <div className="mt-3 space-y-3 rounded-md bg-primary/10 px-3 py-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">선택된 서비스</span>
            <span className="font-bold text-primary">{effectivePrice?.toLocaleString('ko-KR')}원</span>
          </div>

          {hasPromo && (
            <div className="rounded-md bg-white p-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground line-through">
                  정상가 {basePrice?.toLocaleString('ko-KR')}원
                </span>
                <span className="inline-flex items-center rounded-full bg-blue-600 px-2 py-0.5 text-xs font-semibold text-white">
                  프로모션
                </span>
              </div>
              <p className="mt-1 text-sm font-semibold text-foreground">
                프로모션가 {promoPrice?.toLocaleString('ko-KR')}원
              </p>
              <p className="mt-1 text-xs text-blue-700">
                프로모션 상품입니다. 정상가 대비 {discountAmount?.toLocaleString('ko-KR')}원 할인 적용
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ShoeItemCard;